// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Nb4j","index":"styles_index__1pFTZ"};